import { Link, MainLayout, Section } from "@arp/react-ndbx";
import { Paper, Typography } from "@mui/material";
import useTheme from "@mui/material/styles/useTheme";
import React from "react";
import Page from "../../components/Page";
import { URLS } from "../../config/const/enums";
import { errorNotification } from "../../config/disclaimers/disclaimers";
import ArrowBackIcon from "@mui/icons-material/KeyboardBackspaceRounded";

export default function MaintenanceInfo() {
  const theme = useTheme();

  return (
    <Page
      title="Maintenance"
      identifier="Application under maintenance"
      mt={{ xs: 0 }}
    >
      <MainLayout maxWidth="md">
        <Paper
          elevation={0}
          sm={12}
          sx={{
            maxWidth: { sm: 740 },
            mb: { xs: 10 },
          }}
        >
          <Section
            sx={{
              pl: { xs: 4, sm: 8 },
              pr: { xs: 4, sm: 8 },
              pt: { xs: 5 },
              mt: 0,
              mb: 0,
            }}
          >
            <Section sx={{ maxWidth: { xs: 448 }, mb: 4 }}>
              <Section sx={{ mt: 5, mb: { xs: 3, sm: 4 } }}>
                <Section sx={{ mb: 0 }}>
                  <img
                    width="100%"
                    src="https://www.allianzretireplus.com.au/content/dam/onemarketing/azau/allianz-life-dam/images/man_hitting_a_nail_with_hammer.svg"
                  ></img>
                </Section>
              </Section>
            </Section>
          </Section>
          <Section sx={{ mt: 8, mx: 5 }}>
            <Typography variant="h3-bold">
              {errorNotification.IMPROVING_SERVICE}
            </Typography>
          </Section>
          <Section sx={{ mt: 5, mx: { xs: 5, sm: 8 } }}>
            <Typography variant="p3">
              {errorNotification.NOT_AVAILABLE_TRY_AGAIN}
            </Typography>
          </Section>
          <Section
            sx={{ mt: 6, mb: 8, px: 3 }}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <ArrowBackIcon
              sx={{
                fontSize: 16,
                color: theme.palette.action.PrimaryAction600,
              }}
            />
            <Link href={URLS.ALLIANZ_LIFE_HOMEPAGE}>
              {errorNotification.RETURN_ALLIANZ_HOMEPAGE}
            </Link>
          </Section>
        </Paper>
      </MainLayout>
    </Page>
  );
}
